export default __webpack_public_path__ + "images/41723028380f94c107df2967101e4e51-military.webp";